var App = App || {};

App.SiteTour = (function ($) {
    "use strict";

    function init() {
        const siteTour = $("#SiteTourModal");
        if (siteTour.length) {
            SiteTourTriggers(siteTour);
            SiteTourModal(siteTour);
        }
    }

    ////////////////////////////////////////////////////////////////////////////
    // MODAL TRIGGERS
    ////////////////////////////////////////////////////////////////////////////
    function SiteTourTriggers(siteTour) {
        siteTour.modal("show");
        siteTour.find("button[data-bs-dismiss='modal']").on("click", function () {
            App.Cookies.setItem("aboundcu_SiteTour", "closed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
        });
    }

    ////////////////////////////////////////////////////////////////////////////
    // SITE TOUR MODAL
    ////////////////////////////////////////////////////////////////////////////
    function SiteTourModal(siteTour) {

        siteTour.find("button[data-carousel='advance']").on("click", function () {
            splide.go(1);
        });

        siteTour.find("button[data-carousel='reset']").on("click", function () {
            splide.go(0);
        });

        siteTour.find("button[data-modal='scroll']").on("click", function () {
            const target = $(this).parents(".modal");
            const height = $(this).parents(".site-tour-carousel-item").next(".site-tour-carousel-item").position().top;
            const speed = 400;
            target.animate({ scrollTop: height }, speed);
        });

        const carousel = siteTour.find(".site-tour-carousel.splide");
        const current = carousel.find(".site-tour-carousel-status-current");
        const count = carousel.find(".site-tour-carousel-status-count");
        const splide = new Splide(carousel[0], {
            pagination: false,
            breakpoints: {
                991: {
                    destroy: true,
                },
            }
        });

        // Updates the status:
        splide.on('mounted move', function () {
            current.text(splide.index + 1);
            count.text(splide.Components.Controller.getEnd() + 1);
        });

        splide.mount();
    }
    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SiteTour.init();
});